module.exports = __webpack_public_path__ + "fonts/Sarabun-Medium.d497a8b3.ttf";